import configs from "@/i18n/configs"
export default {
    home: 'Home',
    'medRepZone': `${configs.medRepZone.en}`,
    visits: 'Visits',
    'med-rep-plan':`${configs.medRepPlan.en}`,
    'day-off-requests': 'Day off requests',
    'day-off-request': 'Day off request',
    reports: 'Reports',
    'med-rep-mark': `${configs.medRepMark.en}`,
    exams: 'Exams',
    salaries: 'Salaries',
    inventory: 'Inventory',
    'delivery-samples': 'Deliver items',
    'create-samples': 'Create samples',
    statement: 'Statement',
    'products-statement': 'Products statement',
    management: 'Management',
    staff: 'Staff',
    customers: 'Customers',
    'managing-roles': 'Managing roles',
    'external-entities': 'External entities',
    products: 'Products',
    'regions-management': 'Regions management',
    'administrative-zone': 'Administrative Zone',
    'my-visits': 'My visits',
    'report': 'Report',
    'plan': 'Plan',
    logout: 'Logout',

    'add-day-off-request': 'Add day off request',
    'minimal-interface': 'Material stock limit',
    'warehouses-statistics': 'Warehouse statistics',
    'daily-report': 'Daily notes',
    'prices-types': 'Prices types',
    'employee-stock': 'Employee stock',
    'vacations': 'Vacations',
    'specialty-and-teams': 'Sample plan for teams',
    'customers-types': 'Customers Types',
    'administrative-visit': 'Administrative visit'
}